import type { FaireProductEntity } from "../../entity_types/product";

export const p_qnxf8kcgjq: FaireProductEntity = {
  token: "p_qnxf8kcgjq",
  type: "product",
  name: "LA MAISON ROSE",
  brandToken: "b_aqjro3p2",
  brandName: "ROEN",
  imageUrl:
    "https://cdn.faire.com/fastly/34923638a57f965c17ae1600eabfa65e05ebd041fc4a7d8e1c055dfe29636c23.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e8451ea04c93322d2d3566e1df32d18fe47018c2a291f89d8ade77a831f0274e.jpeg",
    "https://cdn.faire.com/fastly/68a6804be5e3120b306655ed18f5d42bb32e918c3151f29fc4e63b381ab87ef8.jpeg",
    "https://cdn.faire.com/fastly/5c0b3240452beda03b4d3a4328d541a540ea5036248a4994ed50080049a7d033.jpeg",
  ],
  priceDollars: 19,
  description:
    "Transport yourself to a picturesque hilltop in Provence, where sun-drenched vineyards and wildflowers adorn the charming landscape of the French countryside. The delicate scent of damask rose intertwines with fresh, green notes of climbing fig. Grounded by the earthy richness of vetiver grass and brightened by the gentle sweetness of flowering linden, creating a scent as serene as the the Provençal hills themselves.\n\ndamask rose, climbing fig, pressed bergamot, vetiver grass, flowering linden\n\nRoen candles are hand poured in our Southern California studio using a coconut + soy wax blend for a natural, clean burn. We use lead-free cotton wicks and premium fragrance oils. All of our candles are vegan, cruelty-free, phthalate-free, paraben-free, carcinogen-free and packaged in fully recyclable materials.\n\n8 ounces (226g), comes in our signature French box.",
  tags: [],
  msrpDollars: 38,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:13:09.109Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
